var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.03 12.47L12 14.44l1.97-1.97a.75.75 0 111.06 1.06l-2.323 2.324a1 1 0 01-1.414 0L8.97 13.53a.75.75 0 111.06-1.06z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11v10a1 1 0 01-1 1H7a1 1 0 01-1-1V11H3a1 1 0 01-1-1V3a1 1 0 011-1h18a1 1 0 011 1v7a1 1 0 01-1 1h-3zM3.5 3.5v6H6v-2H5A.75.75 0 015 6h14a.75.75 0 010 1.5h-1v2h2.5v-6h-17zm4 17v-13h9v13h-9z",
    fill: "currentColor"
  })));
}
SvgWithdrawal.displayName = 'Withdrawal';
export default SvgWithdrawal;